<script>
    import { mapActions, mapState } from "vuex";
    import { formatPrice } from "@/utils";
    import TheSkeleton from "@main/packages/TheSkeleton";
    import BaseAccordion from "@main/packages/BaseAccordion";
    import PaymentIcons from "@/components/PaymentIcons";
    import SchemaFaq from "@/components/schema/SchemaFaq";
    import TypographyWrapper from "@/components/TypographyWrapper";

    export default {
        name: "PaymentContent",
        components: {
            TypographyWrapper,
            SchemaFaq,
            PaymentIcons,
            BaseAccordion,
            TheSkeleton,
        },
        props: {
            leftSideTitle: {
                type: String,
                default: "Доставка",
            },
            rightSideTitle: {
                type: String,
                default: "Оплата",
            },
            hasRightSideIcons: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                activeIndex: 0,
                isLoading: false,
            };
        },
        computed: {
            ...mapState("Root", {
                page: (state) => state.staticPage.payment,
                freeDeliveryCount: (state) => state.site.freeDelivery,
            }),
            contentLeft() {
                return this.page?.contentLeft?.map((item) => {
                    return {
                        title: item.title,
                        desc: item.desc.replace(
                            "#free_delivery#",
                            formatPrice(this.freeDeliveryCount)
                        ),
                    };
                });
            },
        },
        serverPrefetch() {
            return this.getStaticPage({ slug: "payment" });
        },
        mounted() {
            if (!this.page?.slug) {
                this.isLoading = true;
                this.getStaticPage({ slug: "payment" }).then(() => {
                    this.isLoading = false;
                });
            }
        },
        methods: {
            ...mapActions("Root", ["getStaticPage"]),
            changeIndex(index) {
                this.activeIndex = index;
            },
        },
    };
</script>

<template>
    <typography-wrapper>
        <div class="b-text-page">
            <the-skeleton v-if="isLoading" type="text-page"></the-skeleton>
            <template v-if="!isLoading && page">
                <div class="b-text-delivery">
                    <h2 :class="{ 'has-slot': $slots.leftTitle }">
                        {{ leftSideTitle }} <slot name="leftTitle"></slot>
                    </h2>
                    <div class="b-text-delivery__content">
                        <div class="b-text-delivery__accordion">
                            <base-accordion
                                v-for="(item, i) in contentLeft"
                                :key="i + 10"
                                :active-index="activeIndex"
                                :index="i"
                                :accordion="item"
                                custom-type
                                @change="changeIndex"
                            >
                            </base-accordion>
                        </div>
                    </div>
                </div>
                <div class="b-text-payment" id="payment">
                    <h2>{{ rightSideTitle }}</h2>

                    <div class="b-text-payment__content is-payment-page">
                        <div v-html="page.contentRight"></div>
                        <div v-if="hasRightSideIcons" class="b-text-payment__icons">
                            <payment-icons color="dark"></payment-icons>
                        </div>
                    </div>
                </div>
            </template>

            <schema-faq :items="page.contentLeft"></schema-faq>
        </div>
    </typography-wrapper>
</template>

<style lang="scss">
    @import "~@/assets/sass/service-page.scss";
</style>
